<div class="meter">
    <div class="meter-container" matTooltip="Current password strength">
        <div class="meter-item" [style.background-color]="segmentColor(0)"></div>
        <div class="meter-item" [style.background-color]="segmentColor(1)"></div>
        <div class="meter-item" [style.background-color]="segmentColor(2)"></div>
        <div class="meter-item" [style.background-color]="segmentColor(3)"></div>
        <div class="meter-item" [style.background-color]="segmentColor(4)"></div>
    </div>
  <mat-slider matTooltip="Minimum password strength, drag to change" class="slider" min="0" max="5" step="1" value="1"
    (change)="onStrengthMinChange($event)" [disableRipple]="true">
    <input #sliderElem matSliderThumb [(ngModel)]="strengthSlider">
  </mat-slider>
  <div class="feedback" matTooltip="Minimum password strength, drag to change">{{warning()}} {{suggestion()}}</div>
</div>